module.exports = __webpack_public_path__ + "img/circle-chart.ead221b0.svg";